import React from 'react';
import { Helmet } from 'react-helmet';

function ViewListingSEO({title, url, quote}){

    const seoTitle = " - Roba.ba";
    const seoUrl = "https://www.roba.ba";
    const seoLocale = "en_US";
    const seoQuote = !!quote ? quote : "";
    const seoDescription = "Pronađi dobru robu! Roba.ba je online multi-vendor e-commerce rješenje.";

    return(
        <Helmet>
            <title>{title + seoTitle}</title>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="description" content={seoDescription} />
            <meta name="title" key="title" content={title + seoTitle} />
            <meta property="title" content={title + seoTitle}  />
            <meta property="type" content="website" />
            <meta property="url" content={seoUrl + url} />
            <meta property="quote" content={seoQuote} />
            <meta property="og:hashtag" content={"#stiglaroba"} />
            <meta content="image/*" property="og:image:type" />
            <meta property="og:title" content={title + seoTitle} />
            <meta property="og:description" content={seoDescription}/>
            <meta property="og:quote" content={seoQuote} />
            <meta property="og:url" content={seoUrl + url} />
            <meta property="og:locale" content={seoLocale} />
            <meta property="og:site_name" content="Roba.ba"/>
            <meta property="og:type" content="website" />
            {/*Twitter Card tags */}
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={title + seoTitle} />
            <meta name="twitter:description" content={seoDescription} />
        </Helmet>
    );
}

export default ViewListingSEO; 